import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-add-edit-routing-setup',
  templateUrl: './add-edit-routing-setup.component.html',
  styleUrls: ['./add-edit-routing-setup.component.scss']
})
export class AddEditRoutingSetupComponent implements OnInit {

  @Input() routingSetupData: any;
  public _mFormGroup: FormGroup;
  public mSite = new FormControl('', Validators.required);
  public mPriorityOptimization = new FormControl('optimization', Validators.required);
  public mTransportSLA = new FormControl('', Validators.required);
  public mAcceptableDiversion = new FormControl('', Validators.required);
  public mAllowTripGeneration = new FormControl(false);
  public mRoutingType = new FormControl('', Validators.required);
  public mAllowProActiveRouting = new FormControl(false);
  public mAllowTripGenerationOutOfBoundry = new FormControl(false);
  public mAllowDriverToMarkNoShow = new FormControl(false);
  public mShift = new FormControl("");
  public mAllowStopTripToVendor = new FormControl(false);
  public mDisablePickUpTimeUpdateByVendor = new FormControl(false);
  public mRestrictModificationAfterVehicleAllocation = new FormControl(false);
  public mRestrictVendorAllocationForVendor = new FormControl(false);
  public mAutoSaveModifyTrip = new FormControl(false);
  public mIsTripModifyRestrictionReq = new FormControl(false);

  shiftDropDownSettings = {
    singleSelection: false,
    idField: "shiftTimeId",
    textField: "shiftTime",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  routingData: any;
  shiftData: any[] = [];
  shiftMapping: boolean = false;
  siteData: any[] = [];
  title: any;
  mIsEdit: boolean = false;
  editData: any;
  setupFlag: boolean = false;
  mRoutingTyes: any[] = [{ "value": "ALGORITHM" }, { "value": "FIXED" }];

  constructor(private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    public readonly dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService
  ) {

  }

  ngOnInit(): void {
    this._mFormGroup = this.fb.group({
      'site': this.mSite,
      'priorityOptimization': this.mPriorityOptimization,
      'transportSLA': this.mTransportSLA,
      'acceptableDiversion': this.mAcceptableDiversion,
      'allowTripGeneration': this.mAllowTripGeneration,
      'routingType': this.mRoutingType,
      'allowProActiveRouting': this.mAllowProActiveRouting,
      'allowTripGenerationOutOfBoundry': this.mAllowTripGenerationOutOfBoundry,
      'shift': this.mShift,
      'allowStopTripToVendor': this.mAllowStopTripToVendor,
      'disablePickUpTimeUpdateByVendor': this.mDisablePickUpTimeUpdateByVendor,
      'allowDriverToMarkNoShow': this.mAllowDriverToMarkNoShow,
      'restrictModificationAfterVehicleAllocation': this.mRestrictModificationAfterVehicleAllocation,
      'restrictVendorAllocationForVendor': this.mRestrictVendorAllocationForVendor,
      'autoSaveModifyTrip': this.mAutoSaveModifyTrip,
      'isTripModifyRestrictionReq': this.mIsTripModifyRestrictionReq
    });
    this.routingData = this.routingSetupData;
    this.mIsEdit = !!this.routingData;
    this.title = this.mIsEdit ? 'Edit' : 'Add';
    this.getSites();

    if (this.routingData) {
      const defaults = {
        allowMarkNoShow: false,
        allowProActiveRouting: false,
        allowStopTripToVendor: false,
        disablePickUpTimeUpdateByVendor: false,
        allowTripGeneration: false,
        allowTripGenerationOutOffSiteBoundry: false,
        restrictModificationAfterVehicleAllocation: false,
        restrictVendorAllocationForVendor: false,
        autoSaveModifyTrip: false,
        isTripModifyRestrictionReq: false
      };
      Object.keys(defaults).forEach(key => {
        if (this.routingData[key] == null) {
          this.routingData[key] = defaults[key];
        }
      });

      this.mSite.setValue(this.routingData.site.siteId);
      this.getAllShifts(this.mSite.value);
      this.mSite.disable();
      this.mPriorityOptimization.setValue(this.routingData.priorityOptimization);
      this.mAcceptableDiversion.setValue(this.routingData.acceptableDiversion);
      this.mAllowTripGeneration.setValue(this.routingData.allowTripGeneration);
      this.mTransportSLA.setValue(this.routingData.transportSLA);
      this.mRoutingType.setValue(this.routingData.routingType);
      this.mAllowTripGenerationOutOfBoundry.setValue(this.routingData.allowTripGenerationOutOffSiteBoundry);
      this.mAllowProActiveRouting.setValue(this.routingData.allowProActiveRouting);
      this.mAllowStopTripToVendor.setValue(this.routingData.allowStopTripToVendor);
      this.mDisablePickUpTimeUpdateByVendor.setValue(this.routingData.disablePickUpTimeUpdateByVendor);
      this.mAllowDriverToMarkNoShow.setValue(this.routingData.allowMarkNoShow);
      this.mRestrictModificationAfterVehicleAllocation.setValue(this.routingData.restrictModificationAfterVehicleAllocation);
      this.mRestrictVendorAllocationForVendor.setValue(this.routingData.restrictVendorAllocationForVendor);
      this.mAutoSaveModifyTrip.setValue(this.routingData.autoSaveModifyTrip ? this.routingData.autoSaveModifyTrip : false);
      this.mIsTripModifyRestrictionReq.setValue(this.routingData.isTripModifyRestrictionReq ?? false);
    }
  }

  getSites() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getActiveSitesbyUser, (success) => {
      if (success.status == 200) {
        this.siteData = success.body;
      } else if (success.status == 204) {
        this.notifyService.showInfo("No site data found", null);
        this.siteData = [];
      }
    }, (error) => {
      console.log(error);
    });
  }

  getAllShifts(siteId) {
    if (!siteId) return;
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getShiftTimesListBySiteId}?siteId=${siteId}&shiftType=General`,
      (success) => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.shiftData = success.body;
          this.shiftMapping = true;
          if (this.mIsEdit) {
            this.apiService.doGetRequestWithResponse(
              `${ApiConstants.getRoutingConfigShiftsByRoutingId}?routingId=${this.routingData.id}`,
              (success) => this.mShift.setValue(success.status === 200 ? success.body : ''),
              (error) => this.notifyService.showError("Error in getting shifts", null)
            );
          }
        } else {
          this.mShift.setValue('');
          this.shiftData = [];
          this.shiftMapping = false;
          this.notifyService.showInfo("No shifts found for the selected site", null);
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError("Error in getting shifts", null);
      }
    );
  }

  allowTripGenerationToggle() {
    if (this.mAllowProActiveRouting.value) {
      this.mAllowProActiveRouting.setValue(false);
      this.notifyService.showWarning("WARNING! Allow Pro active Routing flag is disabled", null);
    }
  }

  allowProActiveRoutingToggle() {
    if (!this.mAllowProActiveRouting.value) {
      if (this.mAllowTripGeneration.value) {
        this.mAllowTripGeneration.setValue(false);
        this.notifyService.showWarning("WARNING! Allow trip generation before CutOff flag is disabled", null);
      }
    }
  }

  onItemSelect(event) {
  }

  onSelectAll(event) {

  }

  discard_special_char_And_String1(event) {
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return k >= 48 && k <= 57;
  }

  onBack() {
    this.setupFlag = true;
    this._mFormGroup.reset();
  }

  save() {
    if (!this.mShift.value || this.mShift.value.length === 0) {
      this.notifyService.showWarning("Please select the shifts", null);
      return;
    }

    const baseData = {
      acceptableDiversion: this.mAcceptableDiversion.value,
      allowTripGeneration: this.mAllowTripGeneration.value,
      allowProActiveRouting: this.mAllowProActiveRouting.value,
      allowTripGenerationOutOffSiteBoundry: this.mAllowTripGenerationOutOfBoundry.value,
      priorityOptimization: this.mPriorityOptimization.value,
      site: { siteId: this.mSite.value },
      transportSLA: this.mTransportSLA.value,
      routingType: this.mRoutingType.value,
      shifts: this.mShift.value,
      allowStopTripToVendor: this.mAllowStopTripToVendor.value,
      disablePickUpTimeUpdateByVendor: this.mDisablePickUpTimeUpdateByVendor.value,
      allowMarkNoShow: this.mAllowDriverToMarkNoShow.value,
      restrictModificationAfterVehicleAllocation: this.mRestrictModificationAfterVehicleAllocation.value,
      restrictVendorAllocationForVendor: this.mRestrictVendorAllocationForVendor.value,
      autoSaveModifyTrip: this.mAutoSaveModifyTrip.value,
      isTripModifyRestrictionReq: this.mIsTripModifyRestrictionReq.value
    };

    if (this.mIsEdit) {
      this.ngxLoader.start();
      const editData = { ...baseData, id: this.routingData.id, status: this.routingData.status };
      this.apiService.doPutRequestWithResponse(
        ApiConstants.updateRoutingConfig,
        editData,
        (success) => {
          this.ngxLoader.stop();
          const isDuplicateShiftWarning =
            success.body.message === "Routing Setup already exist for selected shifts";
          if (success.status === 200 && !isDuplicateShiftWarning) {
            this.setupFlag = true;
            this.notifyService.showSuccess(success.body.message, null);
          } else {
            this.notifyService.showWarning(success.body.message, null);
          }
        },
        (error) => {
          this.ngxLoader.stop();
          this.notifyService.showError(error.message, null)
        }
      );
    } else {
      const newData = { ...baseData, status: "Active" };
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(
        ApiConstants.addRoutingConfig,
        newData,
        (success) => {
          this.ngxLoader.stop();
          if (success.status === 201) {
            this.setupFlag = true;
            const notifyMethod = success.body.message.includes("Added successfully") ? 'showSuccess' : 'showWarning';
            this.notifyService[notifyMethod](success.body.message, null);
          }
        },
        (error) => {
          this.ngxLoader.stop();
          this.notifyService.showError(error.message, null)
        }
      );
    }
  }

}

